module.exports = __webpack_public_path__ + "img/Darth-Vader-icon.404242b1.png";